import { z } from 'zod';

// ─── Base Models ─────────────────────────────────────────────────────────────

export const HcpProfileConfigVersionSchema = z.object({
  id: z.number().int(),
  configId: z.number().int(),
  versionNumber: z.number().int().min(1),
  config: z.record(z.string(), z.unknown()),
  createdBy: z.number().nullable(),
  createdOn: z.coerce.date(),
  description: z.string().nullable(),
});
export type HcpProfileConfigVersion = z.infer<typeof HcpProfileConfigVersionSchema>;

export const HcpProfileConfigSchema = z.object({
  id: z.number().int(),
  brandIdentifier: z.string(),
  applicationIdentifier: z.string(),
  agentIdentifier: z.string(),
  currentVersionId: z.number().nullable(),
  createdBy: z.number().nullable(),
  createdOn: z.coerce.date(),
  updatedBy: z.number(),
  updatedOn: z.coerce.date(),
});
export type HcpProfileConfigRecord = z.infer<typeof HcpProfileConfigSchema>;

export const HcpProfileConfigDetailSchema = HcpProfileConfigSchema.extend({
  currentVersion: HcpProfileConfigVersionSchema.nullable(),
});
export type HcpProfileConfigDetail = z.infer<typeof HcpProfileConfigDetailSchema>;

// ─── List Response ───────────────────────────────────────────────────────────

export const GetHcpProfileConfigVersionsResponseSchema = z.object({
  versions: z.array(HcpProfileConfigVersionSchema),
});
export type GetHcpProfileConfigVersionsResponse = z.infer<typeof GetHcpProfileConfigVersionsResponseSchema>;

// ─── Request Schemas ─────────────────────────────────────────────────────────

export const CreateHcpProfileConfigRequestSchema = z.object({
  brandIdentifier: z.string(),
  applicationIdentifier: z.string(),
  agentIdentifier: z.string(),
});
export type CreateHcpProfileConfigRequest = z.infer<typeof CreateHcpProfileConfigRequestSchema>;

export const SaveHcpProfileConfigVersionRequestSchema = z.object({
  config: z.record(z.string(), z.unknown()),
  description: z.string().optional(),
});
export type SaveHcpProfileConfigVersionRequest = z.infer<typeof SaveHcpProfileConfigVersionRequestSchema>;
